import { render, staticRenderFns } from "./OSCEChat.vue?vue&type=template&id=5fdab272"
import script from "./OSCEChat.vue?vue&type=script&lang=js"
export * from "./OSCEChat.vue?vue&type=script&lang=js"
import style0 from "./OSCEChat.vue?vue&type=style&index=0&id=5fdab272&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports